import { defineCustomElement } from 'vue';
import Image from "./Image.ce.vue";

customElements.define("web-image", defineCustomElement(Image));
